/* SC Bird Quiz Picker v1.3 (21 Oct 2026). Loaded deferred by sections/sc-bird-quiz-picker.liquid.
   Events (dataLayer, picked up by the GTM ^bird_quiz_ trigger, sent to GA4 under the same names):
     bird_quiz_cta_view  {cta_placement, cta_media}                       once per section, 35% in view
     bird_quiz_cta_click {cta_placement, cta_media, cta_method: chip|button, species}
     cta_media = image or video, what this screen size shows. traffic_type = internal on any theme that is not live.
     Every push sets the other picker keys to undefined, so GTM does not carry a value from one event to the next.
   v1.3: GA4 names (was bq_placement, bq_method, bq_species), cta_media, traffic_type.
   Desktop (hover + 1024px): hovering or focusing a chip shows its photo and size on the media.
   Video: muted loop with no controls, plays in view, pauses out of view, never plays under reduced motion.
   The file comes from data-src-d (769px and wider) or data-src-m (phones). A screen size with no file
   keeps its image. Crossing 769px (rotate, resize) swaps the file or falls back to the image. */
(function () {
  'use strict';
  if (window.SCBQP_INIT) return;
  window.SCBQP_INIT = true;

  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var mqHover = window.matchMedia ? window.matchMedia('(hover: hover) and (min-width: 1024px)') : { matches: false };
  var hasIO = 'IntersectionObserver' in window;

  var KEYS = ['cta_placement', 'cta_media', 'cta_method', 'species', 'traffic_type'];
  function internal() {
    try {
      var s = window.Shopify;
      if (!s) return false;
      if (s.designMode) return true;
      return !!(s.theme && s.theme.role && s.theme.role !== 'main');
    } catch (e) { return false; }
  }
  function push(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: name };
      KEYS.forEach(function (k) { o[k] = undefined; });
      for (var k in data) if (data[k] != null && data[k] !== '') o[k] = data[k];
      if (internal()) o.traffic_type = 'internal';
      window.dataLayer.push(o);
    } catch (e) {}
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || document.documentElement.clientHeight) && r.bottom > 0;
  }

  function init(sec) {
    if (!sec || sec.getAttribute('data-bqp-ready')) return;
    sec.setAttribute('data-bqp-ready', '1');
    var place = sec.getAttribute('data-placement') || 'section';
    var media = sec.querySelector('.sc-bqp__media');
    var badge = sec.querySelector('.sc-bqp__badge');
    var list = sec.querySelector('.sc-bqp__chips');
    var vid = sec.querySelector('.sc-bqp__video');
    /* what this screen size shows right now: the same rule the video code uses below */
    function mediaNow() {
      if (!vid || !hasIO || !window.matchMedia || mqReduce.matches) return 'image';
      var d = window.matchMedia('(min-width: 769px)').matches;
      return vid.getAttribute(d ? 'data-src-d' : 'data-src-m') ? 'video' : 'image';
    }

    /* Entrance: only when the section starts below the screen, so nothing flashes. */
    if (hasIO) {
      if (!mqReduce.matches && !inView(sec)) sec.classList.add('js-anim');
      var seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          sec.classList.add('is-in');
          push('bird_quiz_cta_view', { cta_placement: place, cta_media: mediaNow() });
          seen.disconnect();
        });
      }, { threshold: 0.35 });
      seen.observe(sec);
    } else {
      sec.classList.add('is-in');
    }

    /* Clicks */
    sec.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-bqp-cta]') : null;
      if (!a || !sec.contains(a)) return;
      push('bird_quiz_cta_click', {
        cta_placement: place,
        cta_media: mediaNow(),
        cta_method: a.getAttribute('data-bqp-cta'),
        species: a.getAttribute('data-species') || ''
      });
    });

    /* Desktop hover preview */
    if (list && media) {
      var prev = null;
      var warmed = false;
      function warm() {
        if (warmed) return;
        warmed = true;
        list.querySelectorAll('[data-preview]').forEach(function (c) {
          var im = new Image();
          im.decoding = 'async';
          im.src = c.getAttribute('data-preview');
        });
      }
      function show(chip) {
        if (!mqHover.matches) return;
        var src = chip.getAttribute('data-preview');
        var txt = chip.getAttribute('data-badge');
        if (src) {
          if (!prev) {
            prev = document.createElement('img');
            prev.className = 'sc-bqp__preview';
            prev.alt = '';
            prev.decoding = 'async';
            media.insertBefore(prev, badge || null);
          }
          if (prev.getAttribute('src') !== src) prev.setAttribute('src', src);
          media.classList.add('is-preview');
        } else {
          media.classList.remove('is-preview');
        }
        if (badge && txt) {
          badge.textContent = txt;
          media.classList.add('is-badge');
        } else {
          media.classList.remove('is-badge');
        }
      }
      function hide() {
        media.classList.remove('is-preview', 'is-badge');
      }
      list.addEventListener('pointerenter', warm);
      list.addEventListener('focusin', function (e) {
        warm();
        var c = e.target.closest('.sc-bqp__chip');
        if (c) show(c);
      });
      list.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || !list.contains(e.relatedTarget)) hide();
      });
      list.querySelectorAll('.sc-bqp__chip').forEach(function (c) {
        c.addEventListener('mouseenter', function () { show(c); });
      });
      list.addEventListener('mouseleave', hide);
    }

    /* Video */
    var v = sec.querySelector('.sc-bqp__video');
    if (v && media && hasIO && window.matchMedia) {
      var mqDesk = window.matchMedia('(min-width: 769px)');
      var near = false;
      v.muted = true;
      v.defaultMuted = true;
      v.addEventListener('playing', function () { media.classList.add('is-playing'); });
      function want() {
        if (mqReduce.matches) return '';
        return v.getAttribute(mqDesk.matches ? 'data-src-d' : 'data-src-m') || '';
      }
      function play() {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      function sync() {
        var src = want();
        var cur = v.getAttribute('src') || '';
        if (src !== cur) {
          if (!v.paused) v.pause();
          media.classList.remove('is-playing');
          if (src) {
            v.setAttribute('src', src);
          } else {
            v.removeAttribute('src');
            v.load();
          }
        }
        if (src && near) play();
      }
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          near = e.isIntersecting;
          if (near) sync();
          else if (!v.paused) v.pause();
        });
      }, { threshold: 0.25 });
      vo.observe(media);
      if (mqDesk.addEventListener) mqDesk.addEventListener('change', sync);
      else if (mqDesk.addListener) mqDesk.addListener(sync);
    }
  }

  function boot() {
    document.querySelectorAll('.sc-bqp').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector ? e.target.querySelector('.sc-bqp') : null;
    if (s) init(s);
  });
})();
